import dynamic from 'next/dynamic';
import AnnouncementBarTastic from './bar/announcment';
import HeroTastic from './content/hero';
import FeatureList from './content/feature-list';
import ContentSliderTastic from './content-slider';
import ContentStrip from './content-strip';
import Footer from './footer';
import Header from './header';
import Heading from './heading';
import NotFoundTastic from './not-found';
import SpacerTastic from './spacer';
import { TasticRegistry } from './types';

const Markdown = dynamic(() => import('./markdown'));
const AccountDetails = dynamic(() => import('./account/details'));
const AccountLogin = dynamic(() => import('./account/login'));
const AccountOrdersHistory = dynamic(() => import('./account/orders'));
const AccountRegister = dynamic(() => import('./account/register'));
const ResetPassword = dynamic(() => import('./account/reset-password'));
const Checkout = dynamic(() => import('./checkout'));
const ThankYou = dynamic(() => import('./thank-you'));
const ProductDetails = dynamic(() => import('./products/details'));
const ProductList = dynamic(() => import('./products/product-list'));
const Cart = dynamic(() => import('./cart'));
const HubspotForm = dynamic(() => import('./hubspot-form'));
const AdvertisementTastic = dynamic(() => import('./advertisement'));

export const tastics = {
  'commercetools/ui/checkout': Checkout,
  'commercetools/ui/thank-you': ThankYou,
  'commercetools/ui/footer': Footer,
  'commercetools/ui/header': Header,
  'commercetools/ui/heading': Heading,
  'commercetools/ui/content/hero': HeroTastic,
  'commercetools/ui/content/feature-list': FeatureList,
  'commercetools/ui/content/spacer': SpacerTastic,
  'commercetools/ui/content/markdown': Markdown,
  'commercetools/ui/cart': Cart,
  'commercetools/ui/products/details': ProductDetails,
  'commercetools/ui/products/product-list': ProductList,
  'commercetools/ui/account/details': AccountDetails,
  'commercetools/ui/account/login': AccountLogin,
  'commercetools/ui/account/register': AccountRegister,
  'commercetools/ui/account/orders': AccountOrdersHistory,
  'commercetools/ui/account/reset-password': ResetPassword,
  'commercetools/ui/content/announcement-bar': AnnouncementBarTastic,
  'commercetools/ui/content/advertisement': AdvertisementTastic,
  'commercetools/ui/content/content-slider': ContentSliderTastic,
  'commercetools/ui/not-found': NotFoundTastic,
  'third-parties/ui/hubspot-form': HubspotForm,
  'commercetools/ui/content-strip': ContentStrip,
} as TasticRegistry;
